import React, { FC, useRef, useState } from "react";
import { Button, Icon, TextArea } from "@buderus-apps/components";
import styles from './styles.module.scss'
import { useTranslation } from "react-i18next";
import { PROMPT_MAX_LENGTH } from "../../constants";

const {
  'chat-form': chatForm,
  'chat-form__input': chatFormInput,
  'chat-form__button': chatFormButton,
} = styles

type Props = {
  onSubmitQuestion: (question: string) => void,
  isDisabled: boolean
}
export const ChatForm: FC<Props> = (props) => {
  const { onSubmitQuestion, isDisabled } = props
  const { t } = useTranslation()
  const [question, setQuestion] = useState<string>('')

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleInput = () => {
    const ta = textareaRef.current;
    if (!ta) return;

    const maxRows = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--ai-textarea-max-rows"),
      10
    );
    const initialHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--ai-textarea-height"),
      10
    );

    ta.style.height = "";
    const lineHeight = parseInt(window.getComputedStyle(ta).lineHeight);
    const maxHeight = lineHeight * maxRows;

    if (ta.value === '' || ta.scrollHeight + 2 === initialHeight) {
      ta.style.height = "";
    } else if (ta.scrollHeight <= maxHeight) {
      ta.style.height = ta.scrollHeight + 2 + "px";
      ta.style.overflowY = "hidden";
    } else {
      ta.style.height = maxHeight + "px";
      ta.style.overflowY = "auto";
    }
  };

  return <form
    className={chatForm}
    onSubmit={(event) => {
      event.preventDefault()
      event.stopPropagation()
      onSubmitQuestion(question)
      setQuestion('')
      if (textareaRef.current) {
        textareaRef.current.style.height = ''
      }
    }}
  >
    <TextArea
      ref={textareaRef}
      className={chatFormInput}
      onInput={handleInput}
      onChange={(event) => {
        setQuestion(event.currentTarget.value)
      }}
      onInvalid={(event) => event.preventDefault()}
      maxLength={PROMPT_MAX_LENGTH}
      required
      placeholder={t('INPUT_PLACEHOLDER')}
      id={`ai-search-formfield-layerFooter`}
      value={question}
    />
    <Button
      disabled={isDisabled}
      className={chatFormButton}
      btnStyle={'primary'}
      type='submit'
      icon={<Icon.ArtificialIntelligence/>}
    />
  </form>
}